import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { RebateRequestComponent } from 'src/app/front-user/services/long-haul/rebate-request/rebate-request.component';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { LongHaulService } from 'src/app/shared/services/long-haul.service';
import { ResponseObject } from 'src/app/shared/models/response-object.model';
import { LookupService } from 'src/app/front-user/shared/services/lookup.service';
import { GlobalServices } from 'src/app/shared/services/global.service';
import { GenericLookup } from 'src/app/front-user/shared/models/generic-lookup.model';
import { LongHaulRequestAccurateDataForm } from 'src/app/shared/models/long-haul.model';
import { Country } from 'src/app/front-user/shared/models/country.model';
import { Router } from '@angular/router';

@Component({
  selector: 'app-accurate-data-form',
  templateUrl: './accurate-data-form.component.html'
})

export class AccurateDataFormComponent implements OnInit {
  //#region Properties & Variables
  private rebateRequestId: string = "";
  @ViewChild('rebateRequest',{static: false}) rebateRequest: RebateRequestComponent;
  //Form Properties
  private accurateDataForm: FormGroup;
  private submitAccurateDataFormObject;//: LongHaulRequestAccurateDataForm = new LongHaulRequestAccurateDataForm();
  //Submit
  private submitAccurateDataFormResponseObject: ResponseObject = new ResponseObject();
  private editAccurateDataFormResponseObject: ResponseObject = new ResponseObject();
  public isRequestSucceeded: boolean = false;
  //Get Accurate Data Form
  public countries: GenericLookup[] = [];
  private rates: GenericLookup[] = [];
  private getAccurateDataFormResponseObject: ResponseObject = new ResponseObject();
  private getAccurateDataFormObject: LongHaulRequestAccurateDataForm;
  //Form
  private formMode: FormMode = FormMode.New;
  public submitConfirmationMode: ConfirmationMode = ConfirmationMode.Success;
  @ViewChild ('accurateDataFormControls',{static: false}) accurateDataFormControls: ElementRef;
  //#endregion

  constructor(private lookupService: LookupService,private formBuilder: FormBuilder, private longHaulService: LongHaulService, private globalServices: GlobalServices, private router: Router) { }

  ngOnInit() {
    //Enable Loader
    this.globalServices.isLoaderEnabled = true;
    this.buildForm();
    this.loadCountries();
    this.loadRates();
  }
  loadRates(): void {
    this.lookupService.getRates().subscribe(
      data => this.rates = data.Data as GenericLookup[],
      () => console.log("Something went wrong!!"),
    );
  }
  onRebateRequestLoadedFlag(flag: boolean) {
    if(flag){
      this.rebateRequestId = this.rebateRequest.rebateRequestLoaded.Id;
      this.rebateRequest.showOptionDev = false;
      this.rebateRequest.editModeAdmin = true;
      this.getAccurateDataForm();
    }
  }
  getAccurateDataForm(): void {
    this.longHaulService.getAccurateDataForm(this.rebateRequestId).subscribe(
      data => this.getAccurateDataFormResponseObject = data,
      () => console.log("Something went wrong!!"),
      () => this.getAccurateDataFormCompleted()
    );
  }
  getAccurateDataFormCompleted(): void {
    if(this.getAccurateDataFormResponseObject.Success) {
      this.getAccurateDataFormObject = this.getAccurateDataFormResponseObject.Data as LongHaulRequestAccurateDataForm;
      if(this.getAccurateDataFormObject != null){
        this.formMode = FormMode.Edit;
        this.fillAccurateDataForm();
      }
      const el = document.getElementsByClassName('sectionTitle');
      el[0].scrollIntoView({behavior:'smooth'});
    } else {
      //Enable Error
      this.submitConfirmationMode = ConfirmationMode.Error;
      this.isRequestSucceeded = true;
    }
    //Disable Loader
    this.globalServices.isLoaderEnabled = false;
  }
  fillAccurateDataForm(): void {
    this.accurateDataForm.patchValue({
      DateOfSailing: this.getAccurateDataFormObject.DateOfSailing != null && this.getAccurateDataFormObject.DateOfSailing != "" ? new Date(this.getAccurateDataFormObject.DateOfSailing) : null,
      PortOfOrigin: this.getAccurateDataFormObject.PortOfOrigin,
      PortOfDestination: this.getAccurateDataFormObject.PortOfDestination,
      SCNT: this.getAccurateDataFormObject.SCNT,
      VesselTypeId: this.getAccurateDataFormObject.VesselTypeId != null ? this.getAccurateDataFormObject.VesselTypeId : "",
      Cargo: this.getAccurateDataFormObject.Cargo,
      RateId : this.getAccurateDataFormObject.RateId,
      OtherCharges: this.getAccurateDataFormObject.OtherCharges,
      Deadweight: this.getAccurateDataFormObject.Deadweight,
      NoOfEscTugs: this.getAccurateDataFormObject.NoOfEscTugs,
      NoOfImposedTugs: this.getAccurateDataFormObject.NoOfImposedTugs,
      Remarks: this.getAccurateDataFormObject.Remarks
    });
  }
  buildForm(): void {
    this.accurateDataForm = this.formBuilder.group({
      DateOfSailing: [''],
      PortOfOrigin: [''],
      PortOfDestination: [''],
      //SCNT: ['', [Validators.pattern("^[0-9]{2,2}$")]],
      //SCNT: ['', [Validators.pattern("^[1-9][0-9]*([.][0-9]{1,2}|)$")]],
      SCNT: ['', [Validators.pattern("^[1-9][0-9]{0,5}([.][0-9]{1,2}|)$")]],
      VesselTypeId: [''],
      RateId: [''],
      Cargo: [''],
      OtherCharges: [''],
      Deadweight: [''],
      NoOfEscTugs: [''],
      NoOfImposedTugs: [''],
      Remarks: ['']
    });
  }
  submit(): void {
    const inValidControls = this.accurateDataFormControls.nativeElement.querySelectorAll('.ng-invalid');
    if(inValidControls.length > 0) {
      inValidControls[0].focus();
    } else {
      //Enable Loader
      this.globalServices.isLoaderEnabled = true;
      this.submitAccurateDataFormObject = this.accurateDataForm.value as LongHaulRequestAccurateDataForm;
      this.submitAccurateDataFormObject.Id = this.rebateRequestId;
      if(this.formMode == FormMode.New){
        this.submitAccurateDataForm();
      } else if(this.formMode == FormMode.Edit){
        this.submitAccurateDataFormObject.CreatedBy = this.getAccurateDataFormObject.CreatedBy;
        this.submitAccurateDataFormObject.CreationDate = this.getAccurateDataFormObject.CreationDate;
        this.editAccurateDataForm();
      }
    }
  }
  loadCountries(): void {
    this.lookupService.getCountries().subscribe(
      data => this.countries = data.Data as Country[],
      () => console.log("Something went wrong!!"),
      () => this.loadCountriesCompleted()
    );
  }
  loadCountriesCompleted(): void {
    this.countries.sort((a, b) => (a.NameEN > b.NameEN) ? 1 : -1);
  }
  submitAccurateDataForm(): void {
    this.setDateTimeDefault();
    this.longHaulService.submitAccurateDataForm(this.submitAccurateDataFormObject).subscribe(
      data => this.submitAccurateDataFormResponseObject = data,
      () => console.log("Something went wrong!!"),
      () => this.submitAccurateDataFormCompleted()
    );
  }
  submitAccurateDataFormCompleted(): void {
    if(!this.submitAccurateDataFormResponseObject.Success) {
      //Enable Error
      this.submitConfirmationMode = ConfirmationMode.Error;
    }
    this.isRequestSucceeded = true;
    //Disable Loader
    this.globalServices.isLoaderEnabled = false;
  }
  editAccurateDataForm(): void {
    this.setDateTimeDefault();
    this.longHaulService.editAccurateDataForm(this.submitAccurateDataFormObject).subscribe(
      data => this.editAccurateDataFormResponseObject = data,
      () => console.log("Something went wrong!!"),
      () => this.editAccurateDataFormCompleted()
    );
  }
  editAccurateDataFormCompleted(): void {
    if(!this.editAccurateDataFormResponseObject.Success) {
      //Enable Error
      this.submitConfirmationMode = ConfirmationMode.Error;
    }
    this.isRequestSucceeded = true;
    //Disable Loader
    this.globalServices.isLoaderEnabled = false;
  }
  later(): void {
    this.router.navigateByUrl('/workspace');
  }

  setDateTimeDefault()
  {
    var defaultTimeForDates =  ",12:00:00 PM";
    this.submitAccurateDataFormObject.DateOfSailing != null && this.submitAccurateDataFormObject.DateOfSailing != ""? new Date(this.submitAccurateDataFormObject.DateOfSailing.toLocaleDateString() + defaultTimeForDates) : null;
  }
}

enum FormMode {
  New = 1,
  Edit = 2
}

enum ConfirmationMode {
  Success  = 1,
  Error = 2
}
